'use strict'

import api from '@/api/api';
import userService from '../../services/user.service'

const GETTING_INFO      = 'GET_INFO',
        SET_STATUS = 'SET_STATUS',
      GET_INFO_SUCCESS  = 'GET_INFO_SUCCESS';

export default {
    namespaced: true,
    state:{
        loading: false,
        data: [],
        status: '',
    },
    getters: {
        loading(state) {
            return state.loading;
        },
        data(state) {
            return state.data;
        },
        status(state){
            return state.status
        },
    },
    mutations: {
        [GETTING_INFO](state) {
            state.loading = true;
            state.data = [];
        },
        [GET_INFO_SUCCESS](state, change) {
            state.loading = false;
            state.data = change;
        },
        [SET_STATUS](state, value){
            state.status = value;
        },
    },
    actions:{
        async getQuerys({ commit }, payload) {
            commit(GETTING_INFO);
            try {               
                let normalizedOpt = payload.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s]/g, ""); 
                let token = userService.getMinToken() 
                let headers =  {'Authorization': token} ;

                let response = await api.getQuerys(normalizedOpt, headers);
                commit(GET_INFO_SUCCESS, response.data.result);
               // console.log(response.data.result)
                return response.data.result;
            } catch (error) {
                //console.log(error);
            }
           
        },

       
        
   
    },
}